module.exports = __webpack_public_path__ + "static/media/light-hash-right-1.6b8e7cef.svg";